<mat-card *ngIf="order">
  <div fxLayout="row" fxLayoutAlign="center start">
    <a mat-icon-button class="back" routerLink="/buscar">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div fxFlex>
      <mat-card-title fxLayout="row">
        <div fxFlex>Órden: {{order.id}}</div>
        <div>Estado: {{order.internalStatus}}</div>
      </mat-card-title>
      <mat-card-subtitle fxLayout="row">
        <div fxFlex>Cliente: {{order.clientName}} - ({{order.nit}})</div>
        <div>Estado SGC: {{order.status}}</div>
      </mat-card-subtitle>
    </div>
  </div>
  <mat-card-content>
    <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> Historial </mat-panel-title>
        </mat-expansion-panel-header>
        <app-order-history [orderId]="order.id"></app-order-history>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Contenido de la orden </mat-panel-title>
        </mat-expansion-panel-header>
        <app-order-table [items]="order.items" [orderid]="order.id"></app-order-table>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
